import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

import { PairSearchItemRoot } from './pair-search-item'

type Props = {}

export const PairSearchItemSkeleton: React.FC<Props> = () => {
  return (
    <Root>
      <Favorite height={18} width={18} />
      <Icon>
        <Skeleton height={42} width={42} variant="circular" />
        <IconNetwork
          height={14}
          width={14}
          variant="circular"
          css={`
            position: absolute;
            bottom: 0;
            right: 0;
          `}
        />
      </Icon>
      <PairInformationCurrency>
        <Skeleton height={14} width="60%" />
        <Group>
          <Skeleton height={14} />
          <Skeleton height={14} />
        </Group>
      </PairInformationCurrency>
      <PairInformationInfo>
        <Row>
          <Skeleton height={14} />
          <Skeleton height={14} width="50%" />
        </Row>
        <Row
          css={`
            place-items: end;
            place-self: end;
          `}
        >
          <Skeleton height={14} />
          <Skeleton height={14} width="50%" />
        </Row>
      </PairInformationInfo>
    </Root>
  )
}

const Root = styled(PairSearchItemRoot)`
  &:hover {
    background: var(--background-2);
  }
`

const PairInformationCurrency = styled.div`
  display: grid;

  gap: 6px;
  opacity: 0.5;
  width: 60%;
`

const Group = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 6px;
`

const Icon = styled.div`
  position: relative;
`

const IconNetwork = styled(Skeleton)`
  position: absolute;
  bottom: 0;
  right: 0;

  background: var(--appearance-1);
  border-radius: 50%;
`

const Favorite = styled(Skeleton)`
  opacity: 0.5;
  margin-inline: 3px 7px;
`

const PairInformationInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;

  opacity: 0.5;
`

const Row = styled.div`
  display: grid;
  gap: 6px;
  width: 80%;
`
